// removed by extract-text-webpack-plugin
module.exports = {"subSectionTitle":"LineItemTableSubSectionHeader__subSectionTitle___1nPCE","missing":"LineItemTableSubSectionHeader__missing___1OQnC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CBDTables/LineItemTables/LineItemTablesContainer/LineItemTableSubSection/LineItemSubSectionHeader/LineItemTableSubSectionHeader.less
// module id = 1210
// module chunks = 0